import { EARNINGS_SNAPSHOT_GET_FAILURE, EARNINGS_SNAPSHOT_GET_SUCCESS } from '../actions/types';
import config from '../configs';

const initialState = {
  config,
  isLoading: false,
  isLoaded: false,
  data: [],
};

const earningsSnapshot = (state = initialState, action) => {
  switch (action.type) {
    case EARNINGS_SNAPSHOT_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: action.payload.response,
      };
    }
    case EARNINGS_SNAPSHOT_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: {},
      };
    }
    default: {
      const { options = {} } = action;

      if (options.success === EARNINGS_SNAPSHOT_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }
    }
  }

  return state;
};

export default earningsSnapshot;
